<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>
<div class="container mb-9">
  <div class="columns">
    <div class="column">
      <h1 class="title is-2 has-text-weight-bold has-line">Countries</h1>
      <p>
        The OECD INNOTAX portal covers all OECD member countries, EU member
        states and several other major economies that participate in the OECD
        surveys on R&D tax incentives. The country-specific pages of the OECD
        INNOTAX portal aim to provide a description of the design and
        implementation of R&D tax incentives for all countries that provided R&D
        tax incentives at central government level from 2000 onwards, either on
        a temporary or permanent basis. Click on a country to get information on
        its R&D tax incentives.
      </p>
    </div>
  </div>
  <div class="columns is-multiline mt-1">
    <div
      class="column is-12-mobile is-4-tablet is-3-desktop py-0"
      *ngFor="let country of countries"
    >
      <a
        [routerLink]="['/countries', country.id]"
        class="button is-fullwidth is-square is-white is-flex is-align-items-center is-justify-content-flex-start py-4 my-2"
      >
        <img
          class="flag is-small mr-2"
          src="./assets/images/flags/{{ country.image }}.png"
          alt="{{ country.label }} flag"
        />
        <span class="has-text-weight-normal">{{ country.label }}</span>
      </a>
    </div>
    <ng-container *ngIf="!countries">
      <div class="spinner column is-12">
        <div class="columns is-multiline">
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
          <div class="column is-12-mobile is-4-tablet is-3-desktop py-0">
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start my-2 px-2 py-3"
            >
              <div class="spinner--flag mr-2"></div>
              <div class="spinner--label"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
